import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Button, Checkbox, UIText2 } from '@cian/ui-kit';
import * as React from 'react';
import { getAgreementAccepted } from '../../../../../../services';
import { Link } from '../Link';
import * as styles from './BrokerDescriptionModalFooter.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var BrokerDescriptionModalFooter = function BrokerDescriptionModalFooter(_ref) {
  var isSelfEmployedCheckboxVisible = _ref.isSelfEmployedCheckboxVisible,
    onClose = _ref.onClose,
    onNext = _ref.onNext,
    personalDataAgreementLink = _ref.personalDataAgreementLink;
  var _React$useState = React.useState(getAgreementAccepted() || !isSelfEmployedCheckboxVisible),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isSelfEmployed = _React$useState2[0],
    setSelfEmployed = _React$useState2[1];
  var _React$useState3 = React.useState(getAgreementAccepted()),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    agreedToGivePersonalData = _React$useState4[0],
    setAgreedToGivePersonalData = _React$useState4[1];
  var isNextButtonDisabled = !isSelfEmployed || !agreedToGivePersonalData;
  var changeSelfEmployed = React.useCallback(function () {
    setSelfEmployed(function (isSelfEmployed) {
      return !isSelfEmployed;
    });
  }, []);
  var changeAgreedToGivePersonalData = React.useCallback(function () {
    setAgreedToGivePersonalData(function (agreedToGivePersonalData) {
      return !agreedToGivePersonalData;
    });
  }, []);
  return /*#__PURE__*/_jsxs("div", {
    className: styles['footer'],
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles['checkboxes'],
      children: [isSelfEmployedCheckboxVisible && /*#__PURE__*/_jsxs("div", {
        className: styles['personal-data-checkbox'],
        children: [/*#__PURE__*/_jsx(Checkbox, {
          checked: isSelfEmployed,
          onChange: changeSelfEmployed,
          "data-testid": "SelfEmployedCheckbox"
        }), /*#__PURE__*/_jsx("div", {
          className: styles['personal-data-text'],
          children: /*#__PURE__*/_jsx(UIText2, {
            children: "\u0420\u0430\u0431\u043E\u0442\u0430\u044E \u043A\u0430\u043A \u0441\u0430\u043C\u043E\u0437\u0430\u043D\u044F\u0442\u044B\u0439"
          })
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: styles['personal-data-checkbox'],
        children: [/*#__PURE__*/_jsx(Checkbox, {
          checked: agreedToGivePersonalData,
          onChange: changeAgreedToGivePersonalData,
          "data-testid": "BrokerDescriptionPersonalDataCheckbox"
        }), /*#__PURE__*/_jsx("div", {
          className: styles['personal-data-text'],
          children: /*#__PURE__*/_jsxs(UIText2, {
            children: ["\u0421\u043E\u0433\u043B\u0430\u0448\u0430\u044E\u0441\u044C ", /*#__PURE__*/_jsx(Link, {
              url: personalDataAgreementLink,
              children: "\u043F\u0435\u0440\u0435\u0434\u0430\u0442\u044C \u0441\u0432\u043E\u0438 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435"
            }), " \u043F\u0430\u0440\u0442\u043D\u0451\u0440\u0443 \u0426\u0438\u0430\u043D"]
          })
        })]
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: styles['buttons-wrapper'],
      children: [/*#__PURE__*/_jsx(Button, {
        size: "XS",
        theme: "fill_white_primary",
        onClick: onClose,
        children: "\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C"
      }), /*#__PURE__*/_jsx("div", {
        className: styles['next-button-wrapper'],
        children: /*#__PURE__*/_jsx(Button, {
          size: "XS",
          disabled: isNextButtonDisabled,
          onClick: onNext,
          children: "\u0414\u0430\u043B\u0435\u0435"
        })
      })]
    })]
  });
};